export const AMENITY_TYPE_SECTION = 'SECTION';
export const AMENITY_TYPE_CATEGORY = 'CATEGORY';
export const AMENITY_TYPE_AMENITIES = 'AMENITIES';
export const AMENITIES_SECTION_VIEW = 'section_view';
export const AMENITIES_SECTION_CREATE = 'section_create';
export const AMENITIES_SECTION_EDIT = 'section_edit';
export const AMENITIES_CATEGORY_VIEW = 'category_view';
export const AMENITIES_CATEGORY_CREATE = 'category_create';
export const AMENITIES_CATEGORY_EDIT = 'category_edit';
export const AMENITIES_VIEW = 'amenities_view';
export const AMENITIES_CREATE = 'amenities_create';
export const AMENITIES_EDIT = 'amenities_edit';
export const ASSET_AMENITIES = 'amenities';
export const AMENITIES_TAB_LIST = ['Details', 'Information', 'Media'];
export const AMENITIES_CATEGORY_LIST = ['Details', 'Media'];
export const UPLOAD_PDF = 'Upload PDF';
export const DELETE_MESSAGES = {
  amenityCategory: {
    cannotDelete: 'The selected Item cannot be deleted as it is being added to a hotel compendium.',
    irreversible: 'This action cannot be reversed.',
  },
  amenitySection: {
    cannotDelete: 'The selected Item cannot be deleted as it is being added to a category.',
    irreversible: 'This action cannot be reversed.',
  },
  activityCategory: {
    cannotDelete: 'The selected category cannot be deleted because it contains activities.',
    irreversible: 'This action cannot be reversed.',
  },
};

export const AMENITIES_INFO_TYPES = [
  {
    text: 'Email',
    value: 'EMAIL',
    title: 'Add Email Title',
    valueType: 'Email',
  },
  {
    text: 'URL',
    value: 'URL',
    title: 'Add URL Title',
    valueType: 'URL',
  },
  {
    text: 'Phone Number',
    value: 'PHONE',
    title: 'Add Phone Number Title',
    valueType: 'Phone',
  },
  {
    text: 'Social Media',
    value: 'SOCIAL_MEDIA',
    title: 'Social Media Title (Ex: Instagram / Facebook)',
    valueType: 'URL',
  },
  {
    text: 'PDF',
    value: 'PDF',
    title: '',
    valueType: 'PDF',
  },
];

export const AMENITIES_FILTER_STATUS_SUBMENU = [
  { id: 'active', name: 'Active', selected: false },
  { id: 'inactive', name: 'Inactive', selected: false },
];

export const checkUsageInCollection = (collection, key, selectedValue) => {
  return collection?.some((item) => {
    return item?.[key]?.includes(selectedValue?.id);
  });
};
